export enum TransactionSource {
  TWIC = 'twic',
  ALEGEUS = 'alegeus',
}

export const TWIC_TRANSACTION_TYPES = Object.freeze({
  GROUP: 'group',
  PROGRAM: 'program',
  STORE: 'store',
  REIMBURSEMENT: 'reimbursement',
  CARD: 'card',
});

export const TWIC_TRANSACTION_STATUS = Object.freeze({
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
  FULFILLED: 'fulfilled',
  PROCESSING: 'processing',
  PENDING: 'pending',
  SHIPPED: 'shipped',
  REFUNDED: 'refunded',
});

export const TWIC_WALLET_TRANSACTION_TYPES = Object.freeze({
  DEBIT: 'debit',
  CREDIT: 'credit',
});

export enum TwicWalletTransactionSubtype {
  WALLET_INITIATION = 'wallet_initiation',
  WALLET_RENEW = 'wallet_renew',
  WALLET_RESET = 'wallet_reset',
  WALLET_RENEW_PREV_MONTH_ADJUSTMENT = 'wallet_renew_prev_month_adjustment',
  CHALLENGE_REWARD = 'challenge_reward',
  SUBSCRIPTION_RENEW = 'subscription_renew',
  TRANSACTION_ADJUSTMENT = 'transaction_adjustment',
  TRANSACTION_REFUND = 'transaction_refund',
  TRANSACTION_REFUND_STRIPE = 'transaction_refund_stripe',
  ORDER_PURCHASE = 'order_purchase',
  ORDER_PURCHASE_STRIPE = 'order_purchase_stripe',
  EVENT_REGISTRATION = 'event_registration',
  EVENT_CANCELLATION_REFUND = 'event_cancellation_refund',
  REIMBURSEMENT_APPROVED = 'reimbursement_approved',
  REIMBURSEMENT_ADJUSTMENT = 'reimbursement_adjustment',
  OTHER_ADJUSTMENT = 'other_adjustment',
  OTHER_ADJUSTMENT_ISP = 'other_adjustment_isp',
  OTHER_ADJUSTMENT_ADMIN = 'other_adjustment_admin',
  HISTORICAL_TRANSFER = 'historical_transfer',
}

export const ALEGEUS_TRANSACTION_TYPES = Object.freeze({
  DEPOSIT: 'Deposit',
  CLAIM: 'Claim',
});

export enum AlegeusType {
  DEPOSIT = 'Deposit',
  CLAIM = 'Claim',
}

export const TWIC_WALLET_REFERENCE_TRANSACTION_TYPE = {
  TWIC_CARD_TRANSACTION: 'TwicCardTransaction',
  CLAIM: 'Claim',
};

export const TRANSACTION_PAYMENT_METHODS = Object.freeze({
  CREDIT_CARD: 'credit_card',
  BANK_ACCOUNT: 'bank_account',
  EMPLOYEE_WALLET: 'employee_wallet',
  COUPON: 'coupon',
});

export enum AdjudicationCardReceiptStatus {
  RECEIPT_NOT_REQUIRED = 'receipt_not_required',
  RECEIPT_AWAITING = 'receipt_awaiting',
  RECEIPT_PENDING = 'pending',
  RECEIPT_APPROVED = 'approved',
  RECEIPT_REJECTED = 'rejected',
  RECEIPT_REJECTED_PAID = 'rejected_paid',
}

export enum PretaxWalletTransactionType {
  ALL = 'All',
  CARD = 'Card',
  CLAIM = 'Claim',
  CONTRIBUTION = 'Contribution',
  DEPOSIT = 'Deposit',
  SUBSCRIPTION = 'Subscription',
}

export enum WalletTransactionDateOption {
  LAST_60_DAYS = 'Past_60_days',
  LAST_90_DAYS = 'Past_90_days',
  CURRENT_YEAR = 'current_year',
  LAST_YEAR = 'last_year',
  PAST_YEAR = 'Past_year',
}

export enum WalletTransactionTypeOption {
  ALL = 'all',
  REIMBURSEMENT = 'reimbursement',
  CARD = 'card',
  CREDIT = 'credit',
  STORE = 'store',
}

export enum PretaxTransactionStatus {
  POSTED = 'posted',
  PENDING = 'pending',
}

export enum BackendToClientPretaxTransactionStatusMap {
  posted = 'Complete',
  pending = 'Pending',
}
